import $ from 'jquery';
import Constants from 'root/constants';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';
import View_Project_Performance from 'view/dashboard/performance';

export default View.extend({
    className: 'project-member-access',

    selected_tab: 'about',

    views: {
        project_performance: {}
    },

    events: {
        'input .members-search' : 'onSearch',
        'click .domain-edit'    : 'onDomainEdit'
    },

    dom_handlers: {
        onSearch: function(e) {
            var search_val = $(e.currentTarget).find('input').val().toLowerCase();
            var total_users = 0;

            // users
            var project_users = Cache.app.getUsersByProject(this.model.id);
            project_users.forEach((user) => {
                var match = user.get('name').toLowerCase().indexOf(search_val) !== -1 ||
                            user.get('email').toLowerCase().indexOf(search_val) !== -1;

                this.$el.find('.region-users .member-preview[data-val="' + user.id + '"]').toggle(match);

                if (match) {
                    total_users++;
                }
            });

            // invitations
            Cache.user_invitation.each((model) => {
                var match = model.get('email').toLowerCase().indexOf(search_val) !== -1;

                this.$el.find('.region-invitations .member-preview[data-val="' + model.id + '"]').toggle(match);

                if (match) {
                    total_users++;
                }
            });

            this.$el.find('.members-total').text(total_users + ' member' + (total_users === 1 ? '' : 's'));
        },

        onDomainEdit: function(e) {
            e.preventDefault();
            Modals.editProjectDomains(this.model.id);
        }
    },

    initialize: function(options) {
        if (['about', 'members'].indexOf(options.tab) !== -1) {
            this.selected_tab = options.tab || 'about';
        }

        this.views.project_performance = new View_Project_Performance({
            model: this.model
        });

        this.listenTo(Cache.project_domain, 'add remove', this.render);
    },

    render: function() {
        var domain_options      = '';
        var member_options      = '';
        var invitation_options  = '';
        var project_domains     = Cache.project_domain.where({project_id: this.model.id});
        var project_users       = Cache.app.getUsersByProject(this.model.id, undefined, 'id');
        var project_invitations = [];

        Cache.user_invitation.each((model) => {
            var project_ids = model.get('project_ids').split(',').map((project_id)=> {
                return parseInt(project_id, 10)
            });

            if (project_ids.includes(Cache.default_project_id)) {
                project_invitations.push(model);
            }
        });

        project_domains.forEach((domain) => {
            domain_options += '<li>' + domain.escape('domain') + '</li>';
        });

        project_users.forEach((user) => {
            var member = Cache.workspace_member.findWhere({user_id: user.id});

            member_options +=
            '<div class="member-preview" data-val="' + user.id + '">' +
                '<div><img class="user-32" src="' + user.getAvatar(32) + '"></div>' +
                '<div>' +
                    '<div class="font-weight-medium">' + user.escape('name') + '</div>' +
                    '<div class="member-info">' +
                        '<span class="member-role">' +
                            (member.get('role') === Constants.ADMIN    ? 'Administrator' : '') +
                            (member.get('role') === Constants.ASSIGNEE ? 'Collaborator'  : '') +
                            (member.get('role') === Constants.CLIENT   ? 'Guest'         : '') +
                        '</span>' +
                        (member.hasAccess(Constants.ACCESS_PUBLIC_COMMENT, this.model.id) ? '' : '<span class="member-access">Internal notes only</span>') +
                    '</div>' +
                '</div>' +
                '<div></div>' +
            '</div>';
        });

        project_invitations.forEach((model) => {
            invitation_options +=
            '<div class="member-preview" data-val="' + model.id + '">' +
                '<div><img class="user-32" src="' + Util.gravatar(model.get('email'), 32) + '"></div>' +
                '<div>' +
                    '<span>' + model.escape('email') + '</span>' +
                    '<div class="member-info">' +
                        '<span class="member-role">' +
                            (model.get('role') === Constants.ADMIN    ? 'Administrator' : '') +
                            (model.get('role') === Constants.ASSIGNEE ? 'Collaborator'  : '') +
                            (model.get('role') === Constants.CLIENT   ? 'Guest'         : '') +
                        '</span>' +
                        (model.hasAccess(Constants.ACCESS_PUBLIC_COMMENT, this.model.id) ? '' : '<span class="member-access">Internal notes only</span>') +
                    '</div>' +
                '</div>' +
                '<div><span class="badge-primary-invert badge-small margin-left-4">Pending</span></div>' +
            '</div>';
        });

        var total_users = project_users.length + project_invitations.length;
        var project_creator = Cache.user.get(this.model.get('created_by'));

        var content =
        '<div class="tab">' +
            '<div class="tab-menu">' +
                '<a href="#"' + (this.selected_tab === 'about'   ? ' class="active"' : '') + '>About</a>' +
                '<a href="#"' + (this.selected_tab === 'members' ? ' class="active"' : '') + '>' +
                    '<span class="flex-c">' +
                        '<span>Members</span>' +
                        '<span class="badge-secondary-invert badge-small badge-round badge-fluid font-weight-semibold margin-left-8">' + total_users + '</span>' +
                    '</span>' +
                '</a>' +
            '</div>' +
            '<div class="tab-content">' +
                '<div' + (this.selected_tab === 'about' ? ' class="active"' : '') + '>' +
                    // stats
                    '<div class="region-performance margin-bottom-24"></div>' +

                    // description
                    (this.model.get('description') ?
                    '<div class="box-neutral margin-bottom-24">' + Util.htmlEntities(this.model.get('description'), true) + '</div>' : '') +

                    // domain
                    '<div class="box padding-16 margin-bottom-24">' +
                        '<div class="flex-between">' +
                            '<div class="font-weight-medium">Project domains</div>' +
                            (Cache.app.isAdmin() ?
                            '<a href="#" class="domain-edit primary font-weight-medium">' + (domain_options ? 'Edit' : 'Add') +'</a>' : '') +
                        '</div>' +
                        '<div>' + (domain_options ?  '<ul class="project-domains">' + domain_options + '</ul>' : '<div class="text-info italic margin-top-8">You haven\'t added any project domains yet.</div>') + '</div>' +
                    '</div>' +

                    // created by
                    (this.model.get('create_time') ?
                    '<div class="text-info">Created ' + Util.moment(this.model.get('create_time'), undefined, undefined, false) + (project_creator ? ' by ' + project_creator.escape('name') : '') + '</div>' : '') +
                '</div>' +
                '<div' + (this.selected_tab === 'members' ? ' class="active"' : '') + '>' +
                    '<div class="members-search search-input-medium search-input-solid">' +
                        '<input type="text" placeholder="Search members">' +
                        '<button type="button"><i class="far fa-search"></i></button>' +
                    '</div>' +
                    '<div class="divider-24"></div>' +
                    '<div class="flex-between">' +
                        '<div class="members-total text-info">' + total_users + ' member' + (total_users === 1 ? '' : 's') + '</div>' +
                        (Cache.app.isAdmin() ?
                        '<a href="/member/" class="members-edit navigation primary font-weight-medium">Edit</a>' : '') +
                    '</div>' +
                    '<div class="region-users">' + member_options + '</div>' +
                    '<div class="region-invitations">' + invitation_options + '</div>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        this.views.project_performance.render().$el.appendTo(this.$el.find('.region-performance'));

        return this;
    }
});